// src/components/ui/SubmissionDropdown.jsx

import React from 'react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { MoreVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * SubmissionDropdown
 * Appears only if user is the owner of the submission.
 * Offers Edit/Delete actions.
 */
const SubmissionDropdown = ({ onEdit, onDelete }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="text-swan hover:text-white focus:outline-none"
        >
          <MoreVertical className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-stone-brown border border-field-grey text-swan">
        <DropdownMenuItem
          onClick={onEdit}
          className="cursor-pointer text-imperial-red hover:!text-mikado-yellow"
        >
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={onDelete}
          className="cursor-pointer text-swan hover:bg-field-grey/20"
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SubmissionDropdown;
